import { render, staticRenderFns } from "./OptionCreate.vue?vue&type=template&id=e3a09c3e"
import script from "./OptionCreate.vue?vue&type=script&lang=ts"
export * from "./OptionCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports